import type { FieldError } from '@servicetim/shared';
import { ApiError } from '@servicetim/ui/lib';

/** `errors[]` of a problem+json response, or an empty list for anything else. */
export function fieldErrorsOf(error: unknown): readonly FieldError[] {
  return error instanceof ApiError ? error.fieldErrors : [];
}

/** Errors whose path is `prefix` or nested under it (`statuses.2`, `statuses.2.key`). */
export function errorsAt(errors: readonly FieldError[], prefix: string): FieldError[] {
  return errors.filter((e) => e.path === prefix || e.path.startsWith(`${prefix}.`));
}

/** First message at exactly `path`. */
export function messageAt(errors: readonly FieldError[], path: string): string | undefined {
  return errors.find((e) => e.path === path)?.message;
}

/** Problem `detail` code such as `workflow.status_mapping_required`, when present. */
export function problemDetail(error: unknown): string | null {
  return error instanceof ApiError ? (error.problem?.detail ?? null) : null;
}

/** Everything not consumed by a known prefix; what the banner should still show. */
export function remainingErrors(
  errors: readonly FieldError[],
  consumedPrefixes: readonly string[],
): FieldError[] {
  return errors.filter(
    (e) => !consumedPrefixes.some((p) => e.path === p || e.path.startsWith(`${p}.`)),
  );
}
